export default {
      id: "ico-link-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#ico-link",
      toString: function () {
        return this.url;
      }
    }